/** Open an internal href in a new tab from a click HANDLER (no anchor to
 *  patch), carrying the console-wide tenant scope the way the scope-aware
 *  anchor patch does for real links. Prefer a real `<a target="_blank">` (via
 *  `CellAction.newTab` / `act.filter`) wherever the UI can render one — this is
 *  for grid cell actions that are callbacks by contract. */
import { withScope } from '@/scope/scopeUrl';
import { getTenantScopeList } from '@/scope/tenantScope';

export function openInNewTab(href: string): void {
  const scoped = withScope(
    href,
    getTenantScopeList().map((s) => s.id),
    window.location.origin,
  );
  window.open(scoped, '_blank', 'noopener,noreferrer');
}
